var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[_c('ContentSelect',{attrs:{"cardContent":_vm.dataContent,"funcUpdateProgress":_vm.updateProgress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }